import React from 'react';

import FieldController from '../../../controller/FieldController';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';

class Condition extends React.Component {

  constructor(props) {
    super(props);
    const fields = props.fields;
    this.fieldList = [];
    for(let i = 0; i < fields.length; i++) {
      this.fieldList.push({ id: fields[i].id, value: fields[i].fieldKey,
        type: fields[i].field_type, label: fields[i].label_name });
    }
    const conditions = [];
    this.value={field:'',condition:'',conditions,text:'',fOpt:'',select:'',from:'',to:'',andor:false};
    const filters = this.getConditions(props.value);
    this.state = { filters };
  }

  //componentDidUpdate(props) {
  UNSAFE_componentWillReceiveProps(props) {
    //if(!this.isComponentUpdate) {
      const filters = this.getConditions(props.value);
      this.setState({ ...this.state, filters });
      this.props.onConditionChanged(filters);
      this.isComponentUpdate = true;
    //}
  }

  getConditions = value => value.map((value, i) => {
    const field = this.fieldList.find(field => field.value === value.field);
    if(field === undefined) return { ...this.value };
    const conditions = FieldController.getConditions(field.type);
    const condition = conditions.find(condition => condition.value === value.condition);
    const fOpt = this.getOptionField(field.type, value.condition);
    const options = this.getOptions(fOpt, field.value, value.value);
    const andor = value.andor ? value.andor : false;
    value = value.value;
    return { field, condition, conditions, value, ...fOpt, ...options, andor };
  });

  getOptionField = (type, condition) => {
    const isText = FieldController.showTextFilter(type, condition);
    const isFrom = FieldController.showDateFrom(type, condition);
    const isTo = FieldController.showDateTo(type, condition);
    const isCity = FieldController.showCity(type, condition);
    const isState = FieldController.showState(type, condition);
    const isCountry = FieldController.showCountry(type, condition);
    const isSelect = FieldController.showSelect(type, condition);
    return { isText, isFrom, isTo, isCity, isState, isCountry, isSelect };
  }

  getOptions = (fOpt, field, value) => {
    if(!value) value = '';
    let select = '', options = [], from = null, to = null;
    if(fOpt.isCity) {
      options = FieldController.getOptions({ field_type: Const.City });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isState) {
      options = FieldController.getOptions({ field_type: Const.State });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isCountry) {
      options = FieldController.getOptions({ field_type: Const.Country });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isSelect) {
      options = FieldController.getOptions(this.props.model.fields[field]);
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isFrom || fOpt.isTo) {  
      const dates = value.value.split(Const.Opt);
      from = Util.serverStringDateTimeToDate(dates[0]);
      to = Util.serverStringDateTimeToDate(dates[1]);
    }
    return { select, options, from, to};
  }

  render() {
    return this.state.filters.map((filter, i) =>
      <div key={`condition_${i}`} className="col-md-12 condition-select-div">
        <div className="condition-select col-md-3">
          <span>{filter.field.label}</span> &nbsp;
          <span>{filter.condition.label}</span> &nbsp;
          <span>
            { filter.isText && filter.value }
            { filter.isFrom && Util.serverStringDateTimeToDate(filter.from) }
            { filter.isTo && Util.serverStringDateTimeToDate(filter.from) }
            { (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
              && filter.select.constructor.name === 'Object' && filter.select.label }
            { (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
              && filter.select.constructor.name === 'Array'
              && filter.select.map(tmp => tmp.label).join(`${Const.Comn} `) }
          </span>
        </div>
      </div>
    );
  }
}
export default Condition;